import React from "react";
import { useParams } from "react-router-dom";
import { apiClient } from "src/api/apiService";
import { getFormattedAddress } from "src/components/Premises/helpers";
import { PremiseDetails } from "src/components/Changes/types";
import ChangeRequestContext from "src/context/ChangeRequestContext";
import {
  ChangeRequestFormValues,
  initialValues,
} from "src/components/Form/ChangeRequest/formValue";
import { mapDraftServiceToFormikValues } from "src/components/Form/ChangeRequest/helpers";

export function useChangeRequestEffects() {
  const [formValues, setFormValues] =
    React.useState<ChangeRequestFormValues>(initialValues);
  const [isLoading, setIsLoading] = React.useState(false);
  const { setDraftInfo, setPremiseAddress } =
    React.useContext(ChangeRequestContext);

  const { requestId } = useParams<{ requestId: string }>();

  React.useEffect(() => {
    const getDraftDetails = async () => {
      setIsLoading(true);
      try {
        const { data } = await apiClient.get(`/draft/request/${requestId}`);

        setFormValues(mapDraftServiceToFormikValues(data));

        //set metadata in context
        setDraftInfo({
          draft_id: data.services[0].draft_id ?? "",
          draft_version: data.services[0].draft_version ?? "",
          request_id: data.services[0].request_id ?? "",
          raw_request_status: data.services[0].raw_request_status ?? "",
          request_type: data.services[0].request_type ?? "",
          message_enabled: data.services[0].message_enabled ?? false,
        });

        //set premise address in context
        setPremiseAddress(
          data.premise
            ? getFormattedAddress(data.premise as PremiseDetails)
            : null
        );
      } catch (error) {
        console.error("Error fetching draft details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (requestId) {
      getDraftDetails();
    }
  }, [requestId, setDraftInfo, setPremiseAddress]);

  return { formValues, isLoading };
}
